import React, { FC } from 'react'
import { createStyles, FormControlLabel, makeStyles, Switch, TextField } from '@material-ui/core'
import { useFormik } from 'formik'

export interface IPosOneForm {
    active: boolean
    CodeStore: string // Respetar case en mayusculas
    DispatchCode: string // Respetar case en mayusculas
}

export const initialValues: IPosOneForm = {
    active: false,
    CodeStore: '',
    DispatchCode: '',
}

interface Props extends ReturnType<typeof useFormik> {
    
}

export const PosOneForm: FC<Props> = ({
    values,
    handleChange,
}) => {
    const styles = useStyles()

    return (
        <div className={styles.container}>
            <FormControlLabel
                label={values.active ? 'Activado' : 'Desactivado'}
                control={
                    <Switch checked={values.active} onChange={handleChange('active')}/>
                }
            />
            <TextField className={styles.input} label='CodeStore' value={values.CodeStore} onChange={handleChange('CodeStore')}/>
            <TextField className={styles.input} label='DispatchCode' value={values.DispatchCode} onChange={handleChange('DispatchCode')}/>
        </div>
    )
}

const useStyles = makeStyles(
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        input: {
            marginBottom: 20,
        }
    })
)